export default __webpack_public_path__ + "static/media/mercedesCup-light.aa7f12f6.svg";